














import { Component, Vue, Prop } from 'vue-property-decorator'
import PagContainer from '@/components/pagContainer.vue'
@Component({
  components: {
    PagContainer,
  },
})
export default class Stage extends Vue {
  @Prop({ type: String, default: '' })
  badgeSrc?: string

  @Prop({ type: Number, default: 0 })
  station?: number
}
